import { Home, Wrench, Users } from "lucide-react";

export const services = [
  {
    icon: Home,
    title: "Custom Home Design",
    description:
      "Work with our experienced architects and designers to create a home that perfectly reflects your lifestyle and preferences.",
    features: [
      "Personalized design consultation",
      "Architectural drawings and 3D renderings",
      "Interior design guidance",
      "Sustainable design options",
      "Council approval assistance",
    ],
  },
  {
    icon: Wrench,
    title: "Construction & Build",
    description:
      "Our skilled craftsmen bring your vision to life with quality construction and attention to detail.",
    features: [
      "Licensed and insured builders",
      "Quality materials and finishes",
      "Regular progress updates",
      "Strict quality control processes",
      "Warranty and after-sales support",
    ],
  },
  {
    icon: Users,
    title: "Project Management",
    description:
      "From concept to completion, our project managers ensure your build runs smoothly and on schedule.",
    features: [
      "Dedicated project manager",
      "Timeline and milestone tracking",
      "Coordination with subcontractors",
      "Budget management and reporting",
      "Regular site inspections",
    ],
  },
];

export const process = [
  {
    step: "01",
    title: "Initial Consultation",
    description:
      "We meet to discuss your vision, budget, and timeline. Our team will assess your needs and provide initial guidance.",
  },
  {
    step: "02",
    title: "Design & Planning",
    description:
      "Our architects create detailed plans and 3D renderings. We work together to refine the design until it's perfect.",
  },
  {
    step: "03",
    title: "Approvals & Permits",
    description:
      "We handle all council approvals and building permits, ensuring your project meets all regulatory requirements.",
  },
  {
    step: "04",
    title: "Construction",
    description:
      "Our skilled team begins construction with regular updates and quality checks throughout the build process.",
  },
  {
    step: "05",
    title: "Completion & Handover",
    description:
      "Final inspections, walkthrough, and handover of your completed home with comprehensive warranty coverage.",
  },
];
